import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import AOS from "aos";
import { Bar } from "react-chartjs-2";
import "chart.js/auto";
import "./ProductionData.css";
import Footer from "../Home/Footer";
import AsiaImage from "../assets/img/Asia.jpg";
import NorthAmericaImage from "../assets/img/NorthAmerica.jpg";
import SouthAmericaImage from "../assets/img/SouthAmerica.jpg";
import Europe from "../assets/img/Europe.jpg";
import ProductionSlider1 from "../assets/img/ProductionSlider-1.jpg";

const ProductionData = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const productionStats = [
    { title: "Total Soybean Production", value: "120 Million Tons" },
    { title: "Annual Growth Rate", value: "4.2%" },
    { title: "Top Producing Country", value: "Brazil" },
    { title: "Export Volume", value: "90 Million Tons" },
  ];

  const regionalData = [
    {
      region: "North America",
      production: "40M Tons",
      image: NorthAmericaImage,
    },
    {
      region: "South America",
      production: "50M Tons",
      image: SouthAmericaImage,
    },
    {
      region: "Asia",
      production: "20M Tons",
      image: AsiaImage,
    },
    {
      region: "Europe",
      production: "10M Tons",
      image: Europe,
    },
  ];

  const productionData = {
    labels: ["2019", "2020", "2021", "2022", "2023"],
    datasets: [
      {
        label: "Soybean Production (Million Tons)",
        data: [95, 100, 110, 115, 120],
        backgroundColor: "#d4561a",
        borderRadius: 8,
      },
    ],
  };

  return (
    // <div className="production-data-page">
    //   {/* Hero Section */}
    //   <section
    //     className="hero-section-production"
    //     style={{
    //       background: `url(${ProductionSlider1}) no-repeat center center/cover`,
    //     }}
    //   >
    //     <div className="overlay"></div>
    //     <div className="container text-center">
    //       <h1 data-aos="fade-down" style={{ color: "#d4561a" }}>
    //         Production Data
    //       </h1>
    //       <p data-aos="fade-up">
    //         Get insights into global soybean production statistics, trends, and
    //         regional data.
    //       </p>
    //     </div>
    //   </section>

    //   {/* Production Statistics */}
    //   <section className="statistics-section container">
    //     <h2 className="production-section-title" data-aos="fade-up">
    //       Global Production Statistics
    //     </h2>
    //     <div className="stats-grid">
    //       {productionStats.map((stat, index) => (
    //         <div key={index} className="stat-card" data-aos="zoom-in">
    //           <h3>{stat.value}</h3>
    //           <p>{stat.title}</p>
    //         </div>
    //       ))}
    //     </div>
    //   </section>

    //   {/* Graphical Representation */}
    //   <section className="graph-section container">
    //     <h2 className="production-section-title" data-aos="fade-up">
    //       Production Trends Over the Years
    //     </h2>
    //     <div className="chart-container" data-aos="fade-right">
    //       <Bar data={productionData} />
    //     </div>
    //   </section>

    //   {/* Regional Data Breakdown */}
    //   <section className="regional-section container">
    //     <h2 className="production-section-title" data-aos="fade-up">
    //       Regional Production Breakdown
    //     </h2>
    //     <div className="regional-grid">
    //       {regionalData.map((region, index) => (
    //         <div key={index} className="region-card" data-aos="zoom-in">
    //           <img src={region.image} alt={region.region} />
    //           <h3>{region.region}</h3>
    //           <p>{region.production}</p>
    //         </div>
    //       ))}
    //     </div>
    //   </section>

    //   {/* Government Insights & Reports */}
    //   <section className="reports-section container">
    //     <h2 className="production-section-title" data-aos="fade-up">
    //       Government Reports & Insights
    //     </h2>
    //     <ul data-aos="fade-left">
    //       <li>
    //         📑 <a href="#">Soybean Market Analysis Report 2024</a>
    //       </li>
    //       <li>
    //         📑 <a href="#">Global Production Forecast</a>
    //       </li>
    //       <li>
    //         📑 <a href="#">Impact of Climate Change on Yield</a>
    //       </li>
    //     </ul>
    //   </section>
    //   <Footer />
    // </div>
    <section id="recent-posts" className="recent-posts section">
      <div className="container">
        <div className="row justify-content-center text-center">
          <div className="col-lg-8">
            <div
              className="p-5 rounded shadow"
              style={{ backgroundColor: "#fff8e1" }}
            >
              <h2
                className="mb-3"
                style={{ fontSize: "2rem", color: "#ff6f00" }}
              >
                🚧 Coming Soon
              </h2>
              <p style={{ fontSize: "1.1rem", color: "#555" }}>
                This section is under construction. Stay tuned for our latest
                posts and updates!
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductionData;
